import { useAgentChatImageGeneration } from './useAgentChatImageGeneration';
import { createRecommendationTrackingWrapper } from './createRecommendationTrackingWrapper';
import { MessageDisplay } from '../../types/chat-hook-types';

/**
 * Image generation with recommendation tracking
 * Auto-generated using the standardized factory pattern
 * Now supports both temporary and database IDs for reliability
 */
export const useAgentChatImageGenerationWithTracking = (message: MessageDisplay | string) => {
  // Apply tracking wrapper
  const trackingWrapper = createRecommendationTrackingWrapper(
    useAgentChatImageGeneration,
    'image',
    {
      // Simplified metadata for private image tracking (no project dependencies)
      getMetadata: (params, result) => ({
        description: params.image?.description || 'Private Generated Image',
        size: params.image?.size || '1024x1024',
        style: params.image?.style || 'photo',
        imageUrl: result.imageUrl,
        savedImageId: result.savedImageId // Include savedImageId for navigation
        // No workbookId - private image
      }),
      // Use the saved image ID from the result
      getSavedItemId: (result) => result.savedImageId // Use savedImageId instead of id
    }
  );
  
  return trackingWrapper(message);
}; 